import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { Brandmark } from '../Icons';
import Button from '../Button';
import Link from '../Link';
import Style from '../Style';
import { H3, L3, P1 } from '../Typography';

class ClipDownloading extends React.PureComponent {
  static propTypes = {
    downloadUrl: PropTypes.string,
    backTo: PropTypes.string,
    onBackTo: PropTypes.func,
    goTo: PropTypes.string,
    onGoTo: PropTypes.func,
  };
  static defaultProps = {};

  render() {
    const {
      downloadUrl,
      backTo,
      onBackTo,
      goTo,
      onGoTo,
      ...otherProps
    } = this.props;

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          color: Style.Colors.white,
        }}
      >
        <div style={{ padding: '6rem 7rem 0' }}>
          <Brandmark color={Style.Colors.white} />
        </div>
        <div
          style={{
            maxWidth: '55rem',
            margin: '10rem auto 0',
            opacity: downloadUrl ? 1 : 0,
          }}
        >
          <L3 style={{ color: '#9B9B9B' }}>SUCCESS</L3>
          <H3 style={{ margin: '0.8rem 0' }}>Your clip is downloading now!</H3>
          <P1 style={{ opacity: 0.75 }}>
            If your download hasn’t started after a few seconds, you can{' '}
            <Link target="_self" underline={true} to={downloadUrl}>
              click here
            </Link>{' '}
            to restart!
          </P1>
          <div
            style={{
              marginTop: '4.5rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              arrow={true}
              baseColor={Style.Colors.black}
              onClick={onBackTo}
            >
              Back to {backTo}
            </Button>
            <span style={{ margin: '0 2rem' }}>or</span>
            <Button baseColor={Style.Colors.black} onClick={onGoTo}>
              Go to {goTo}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ClipDownloading;



// WEBPACK FOOTER //
// ./src/components/ClipDownloading/ClipDownloading.js